<template lang="pug">
section.single
  Header
  template(v-if="mode !== 'initialized'")
    .subheader.d-flex.justify-content-center.align-items-center
      .steps.d-flex
        .step(:class="mode === 'input' ? 'active' : ''") STEP 1 - 基本情報の入力
        .step(:class="mode === 'confirm' ? 'active' : ''") STEP 2 - 内容確認・登録
    .container.py-5
      .row(v-if="mode === 'input'")
        .col.text-center
          b-button.mb-2(variant="link",size="sm",href="/terms",target="_blank")
            span.mr-2 利用規約を表示
            i.far.fa-clone

          p.mb-5
            b-button.px-4.py-3(pill,variant="primary",size="sm",:pressed.sync="agree")
              i.fas.fa-check-square(v-if="agree")
              i.far.fa-square(v-if="!agree")
              span.ml-3 利用規約に同意する

          b-button.mb-2(variant="link",size="sm",href="/privacy",target="_blank")
            span.mr-2 プライバシーポリシーを表示
            i.far.fa-clone

          p.mb-5
            b-button.px-4.py-3.bg-white(pill,variant="primary",size="sm",:pressed.sync="privacy")
              i.fas.fa-check-square(v-if="privacy")
              i.far.fa-square(v-if="!privacy")
              span.ml-3 プライバシーポリシーに同意する

      ValidationObserver(slim,ref="observer")
        b-form.form(v-if="id && email",ref="form",@submit.prevent)
          b-row(v-if="mode === 'confirm'")
            b-col(cols=12)
              p.font-weight-bolder.text-center.mb-5
                | 入力内容を確認して、一番下の登録ボタンを押してください。
          ValidationObserver(slim,ref="observer",v-slot="{ invalid }")
            b-row
              b-col(cols=12)
                h3 1. ディレクトリ
            b-row
              b-col(cols=6)
                b-form-group(label="ディレクトリ",label-for="input-directory",description="英小文字・数字またはハイフン。3〜15文字で指定してください",required)
                  ValidationProvider(ref="directory",:rules="{ required: true, min: 3, max: 15, regex: /^[a-z][a-z0-9\-]+[a-z0-9]$/ }",name="ディレクトリ",v-slot="{ errors }")
                    b-form-input#input-directory(ref="input-directory",v-model="datum.directory",type="text",required,placeholder="ディレクトリを入力してください",@input="checkInput",:state="validDirectory",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row.mt-3
              b-col(cols=12)
                h3 2. 利用者情報
            b-row
              b-col(cols=6)
                //-b-form-group.email(label="メールアドレス",label-for="input-email",description="")
                  b-form-input#input-email(ref="input-email",:value="email",type="text",:disabled="true")
                b-form-group(label="氏名",label-for="input-username",description="",required)
                  ValidationProvider(rules="required",name="氏名",v-slot="{ errors }")
                    b-form-input#input-username(ref="input-username",v-model="datum.username",type="text",required,placeholder="氏名を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="携帯電話番号",label-for="input-mobile",description="")
                  ValidationProvider(:rules="{ regex: /^0[0-9]{1,4}\-?[0-9]{1,4}\-?[0-9]{4}$/, min: 10, max: 20 }",name="携帯電話番号",v-slot="{ errors }")
                    b-form-input#input-mobile(v-model="datum.mobile",type="tel",placeholder="携帯電話番号を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=6)
                b-form-group(label="部署",label-for="input-department",description="")
                  ValidationProvider(rules="",name="部署",v-slot="{ errors }")
                    b-form-input#input-department(v-model="datum.department",type="text",placeholder="部署を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="役職",label-for="input-position",description="")
                  ValidationProvider(rules="",name="役職",v-slot="{ errors }")
                    b-form-input#input-position(v-model="datum.position",type="text",placeholder="役職を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

            b-row.mt-3
              b-col(cols=12)
                h3 3. 会社情報
            b-row
              b-col(cols=6)
                b-form-group(label="社名",label-for="input-companyname",description="",required)
                  ValidationProvider(rules="required",name="社名",v-slot="{ errors }")
                    b-form-input#input-companyname(v-model="datum.companyname",type="text",required,placeholder="社名を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="社員数",label-for="input-headcount",description="",required)
                  ValidationProvider(rules="required|min_value:1",name="社員数",v-slot="{ errors }")
                    b-form-input#input-headcount(v-model="datum.headcount",type="number",required,placeholder="社員数を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=6)
                b-form-group(label="設立年月日",label-for="input-foundationDate",description="")
                  ValidationProvider(rules="date",name="設立年月日",v-slot="{ errors }")
                    b-input-group
                      b-form-input#input-foundationDate(v-model="datum.foundationDate",type="text",placeholder="設立年月日を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                      b-input-group-append
                        b-form-datepicker(v-model="datum.foundationDate",button-only,right,locale="ja-JP",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="業界",label-for="input-segment",description="",required)
                  ValidationProvider(rules="required",name="業界",v-slot="{ errors }")
                    b-form-select#input-segment(v-model="datum.segment",:options="options.segments",placeholder="業界を選択してください",@change="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=6)
                b-form-group(label="代表者名",label-for="input-president",description="",required)
                  ValidationProvider(rules="required",name="代表者名",v-slot="{ errors }")
                    b-form-input#input-president(v-model="datum.president",type="text",required,placeholder="代表者名を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="会社ホームページURL",label-for="input-url",description="")
                  ValidationProvider(:rules="{ regex: /^https?:\\/\\/[-a-zA-Z0-9@:%._\\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)$/ }",name="URL",v-slot="{ errors }")
                    b-form-input#input-url(v-model="datum.url",type="url",placeholder="URLを入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=6)
                b-form-group(label="代表電話番号",label-for="input-tel",description="",required)
                  ValidationProvider(:rules="{ required: true, regex: /^0[0-9]{1,4}\-?[0-9]{1,4}\-?[0-9]{4}$/, min: 10, max: 20 }",name="代表電話番号",v-slot="{ errors }")
                    b-form-input#input-tel(v-model="datum.tel",type="tel",required,placeholder="電話番号を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col(cols=6)
                b-form-group(label="郵便番号",label-for="input-zip",description="",required)
                  ValidationProvider(:rules="{ required: true, regex: /^[0-9]{3}-?[0-9]{4}$/ }",name="郵便番号",v-slot="{ errors }")
                    b-form-input#input-zip(v-model="datum.zip",type="text",placeholder="郵便番号を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
              b-col(cols=6)
                b-form-group(label="都道府県",label-for="input-prefecture",description="",required)
                  ValidationProvider(rules="required",name="都道府県",v-slot="{ errors }")
                    b-form-select#input-prefecture(v-model="datum.prefecture",:options="options.prefectures",required,placeholder="都道府県を選択してください",@change="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col
                b-form-group(label="市区町村・番地",label-for="input-locality",description="",required)
                  ValidationProvider(rules="required",name="市区町村・番地",v-slot="{ errors }")
                    b-form-input#input-locality(v-model="datum.locality",type="text",placeholder="市区町村・番地を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}
            b-row
              b-col
                b-form-group(label="ビル・マンション名など",label-for="input-building",description="")
                  ValidationProvider(rules="",name="ビル・マンション名",v-slot="{ errors }")
                    b-form-input#input-building(v-model="datum.building",type="text",placeholder="ビル・マンション名を入力してください",@input="checkInput",:disabled="!editable || !agree || !privacy",:readonly="!editable || !agree || !privacy")
                    .form-control-feedback.text-danger(v-if="errors.length > 0") {{ errors[0] }}

            .text-center.mt-5
              template(v-if="mode === 'input'")
                b-button(pill,variant="primary",@click="onConfirm()",:disabled="!valid")
                  // i.fas.fa-save
                  span 内容確認に進む
              template(v-if="mode === 'confirm'")
                b-button(pill,variant="secondary",@click="onBack()")
                  // i.fas.fa-save
                  span 入力に戻る
                b-button.ml-3(pill,variant="primary",@click="onSave()")
                  // i.fas.fa-save
                  span 上記の内容で登録する
              //-p.mt-4
                b-button(variant="link",@click="onCancel()") 登録をキャンセルする
  template(v-if="mode === 'initialized'")
    .message
      p ありがとうございます。登録が完了しました。
    .container
      .box
        .header.text-center.mb-5.pb-3
          //-h1.title 登録完了
          .text-center.mt-5
            p
              | 基本情報の登録が完了しました。
              br
              | ログインするとご利用を開始していただけます。
              br
            p.mt-5
              b-button(pill,variant="primary",@click="onNext()")
                // i.fas.fa-save
                span ログインへ
            //-p.mt-4
              a(href="/")
                span キャンセル
  Footer
</template>

<script>
import _ from 'lodash'

import { getData, postData } from '../utils/api'

import { optionsSegment, optionsPrefecture } from '../utils/libs'

const otherUrl = `${process.env.VUE_APP_APP_PROTOCOL}://${process.env.VUE_APP_APP_DOMAIN}/*/`

const page = {
  id: 'initial',
  title: '初期設定'
}

export default {
  data () {
    return {
      mask: false,
      mode: 'input',
      editable: true,
      page: page,
      agree: false,
      privacy: false,
      id: null,
      email: null,
      validDirectory: null,
      datum: {
        segment: '',
        prefecture: ''
      },
      valid: false,
      options: {
        segments: [],
        prefectures: []
      }
    }
  },
  watch: {
    'datum.zip' (val) {
      this.changeZip()
    }
  },
  created () {
    let yubinbangoScript = document.createElement('script')
    yubinbangoScript.setAttribute('src', 'https://yubinbango.github.io/yubinbango-core/yubinbango-core.js')
    document.head.appendChild(yubinbangoScript)
  },
  async mounted () {
    if (!this.$route.query || !this.$route.query.code) {
      this.msgBoxError('Incorrect Access')
    }
    this.options.segments = optionsSegment()
    this.options.segments.unshift({
      value: '', text: '業界を選択してください'
    })
    this.options.prefectures = optionsPrefecture()
    this.options.prefectures.unshift({
      value: '', text: '都道府県を選択してください'
    })

    let message = ''

    if (this.$route.query.code) {
      try {
        await postData('/verified', {
          code: this.$route.query.code
        }).then((datum) => {
          if (!datum) {
            this.$bvModal.msgBoxOk('メールアドレスが登録されていません')
          } else {
            this.id = datum._id
            this.email = datum.email
          }
        }).catch((err) => {
          console.error(err)
          message = 'データの読込に失敗しました'

          if (err.response.data) {
            if (err.response.data.code && err.response.data.message) {
              message = err.response.data.message
            } else if (err.response.data.message) {
              message = err.response.data.message
            }
          }
        })
      } catch (e) {
        message = 'データの読込に失敗しました'
      }
    } else {
      message = 'Incorrect Access'
    }

    if (message) {
      this.msgBoxError(message)
    }
  },
  methods: {
    changeZip () {
      if (this.mask) { return }
      if (this.datum.zip && this.datum.zip.match(/^[0-9]{3}-?[0-9]{4}$/)) {
        const self = this
        new YubinBango.Core(this.datum.zip, (address) => {
          this.$set(self.datum, 'prefecture', address.region)
          this.$set(self.datum, 'locality', address.locality + address.street)
        })
      }
    },
    async checkInput () {
      this.valid = await this.$refs.observer.validate()
      /*
      const fields = this.$refs.observer.fields
      for (let name in fields) {
        if (fields[name].invalid) {
          this.valid = false
          break
        }
      }
      */

      this.validDirectory = await this.checkDirectory()
      if (!this.validDirectory) {
        if (this.valid) {
          this.valid = false
        }
        this.$refs.directory.errors.push('すでに使用されています')
      }

      return this.valid
    },
    async checkDirectory () {
      let ret = false
      if (!this.editable || _.isUndefined(this.datum.directory)) {
        return
      } else {
        try {
          await getData(`/existsDirectory?directory=${this.datum.directory}`).then(async (res) => {
            if (res) {
              ret = true
            }
          })
        } catch (e) {
        }
      }
      return ret
    },
    async onConfirm () {
      if (!await this.checkInput()) {
        this.$bvModal.msgBoxOk('入力内容を確認してください')
      } else {
        window.scrollTo(0, 0)
        this.mode = 'confirm'
        this.editable = false
        this.validDirectory = null
      }
    },
    onBack () {
      this.$set(this, 'mode', 'input')
      this.$set(this, 'editable', true)
    },
    async onSave () {
      this.doSave()
    },
    async doSave () {
      this.mask = true

      let message

      this.datum.code = this.$route.query.code

      await postData(`/initialize`, this.datum).then(async (json) => {
        this.mode = 'initialized'
        // this.$bvModal.msgBoxOk('利用情報の登録が完了しました')
      }).catch((err) => {
        console.error(err)

        message = '利用情報の登録に失敗しました'

        if (err.response && err.response.data) {
          if (err.response.data.code && err.response.data.message) {
            message = err.response.data.message
          } else if (err.response.data.message) {
            message = err.response.data.message
          }
        }
      })

      this.mask = false

      if (message) {
        this.msgBoxError(message)
      } else {
        this.$forceUpdate()
      }
    },
    onNext () {
      window.location.href = otherUrl.replace('*', this.datum.directory)
    }
  }
}
</script>

<style scoped lang="stylus">
.form-group.email >>> label::after
  content ''
.subheader
  top 60px
  width 100%
  min-width 991px !important
  text-align center
  vertical-align middle
  height 100px
  background-color #5d3ea0
  background url("../assets/images/bgMessage.svg")
  background-size cover
  background-repeat no-repeat
  background-position center center
  .steps
    color white
    font-size 1.125rem
    .step
      font-size 0.875rem
      padding 0.75rem 2rem
      border-radius 1.5rem
      border 1px solid #fff
      width 15rem
      &.active
        background-color #fff
        color #444
      &:first-child
        margin-right 2.5rem
        position relative
        &:after
          position absolute
          content ''
          top 1.325rem
          left 15.75rem
          width 3rem
          background-color white
          height 1px
      &:last-child
        margin-left 2.5rem
.form
  max-width 800px
  margin auto
</style>
